module.exports = __webpack_public_path__ + "img/visiteActive.5aa5b1cb.png";